import React from 'react';

export const Airwaves = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1.543 3.982 90 24"
      width="90"
      height="24"
      fill="#163e63"
    >
      <path
        d="M 40.235 -12.442 L 42.235 -12.442 L 42.235 -6.442 L 40.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -47.765 -28.442 L -45.765 -28.442 L -45.765 -18.442 L -47.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -43.765 -28.442 L -41.765 -28.442 L -41.765 -18.442 L -43.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -43.765 -20.442 L -33.765 -20.442 L -33.765 -18.442 L -43.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -43.765 -28.442 L -33.765 -28.442 L -33.765 -26.442 L -43.765 -26.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -28.442 L -29.765 -28.442 L -29.765 -18.442 L -31.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -23.765 -28.442 L -21.765 -28.442 L -21.765 -22.442 L -23.765 -22.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -20.442 L -21.765 -20.442 L -21.765 -18.442 L -31.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -19.765 -28.442 L -17.765 -28.442 L -17.765 -18.442 L -19.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -19.765 -20.442 L -9.765 -20.442 L -9.765 -18.442 L -19.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -28.442 L -21.765 -28.442 L -21.765 -26.442 L -31.765 -26.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -24.442 L -21.765 -24.442 L -21.765 -22.442 L -31.765 -22.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 20.235 -16.442 L 22.235 -16.442 L 22.235 -6.442 L 20.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 28.235 -16.442 L 30.235 -16.442 L 30.235 -10.442 L 28.235 -10.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 20.235 -8.442 L 30.235 -8.442 L 30.235 -6.442 L 20.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 20.235 -16.442 L 30.235 -16.442 L 30.235 -14.442 L 20.235 -14.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 20.235 -12.442 L 30.235 -12.442 L 30.235 -10.442 L 20.235 -10.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 32.235 -16.442 L 34.235 -16.442 L 34.235 -10.442 L 32.235 -10.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 32.235 -8.442 L 42.235 -8.442 L 42.235 -6.442 L 32.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 32.235 -16.442 L 42.235 -16.442 L 42.235 -14.442 L 32.235 -14.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 32.235 -12.442 L 42.235 -12.442 L 42.235 -10.442 L 32.235 -10.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -7.765 -28.442 L -5.765 -28.442 L -5.765 -18.442 L -7.765 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 0.235 -28.442 L 2.235 -28.442 L 2.235 -18.442 L 0.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -7.765 -28.442 L 2.235 -28.442 L 2.235 -26.442 L -7.765 -26.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 4.235 -28.442 L 6.235 -28.442 L 6.235 -18.442 L 4.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 12.235 -28.442 L 14.235 -28.442 L 14.235 -18.442 L 12.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 4.235 -28.442 L 14.235 -28.442 L 14.235 -26.442 L 4.235 -26.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 16.235 -28.442 L 18.235 -28.442 L 18.235 -18.442 L 16.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 24.235 -30.442 L 26.235 -30.442 L 26.235 -18.442 L 24.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 16.235 -28.442 L 26.235 -28.442 L 26.235 -26.442 L 16.235 -26.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 16.235 -20.442 L 26.235 -20.442 L 26.235 -18.442 L 16.235 -18.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -7.765 -22.442 L 2.235 -22.442 L 2.235 -20.442 L -7.765 -20.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -47.765 -16.442 L -45.765 -16.442 L -45.765 -6.442 L -47.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -39.765 -16.442 L -37.765 -16.442 L -37.765 -6.442 L -39.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -35.765 -16.442 L -33.765 -16.442 L -33.765 -6.442 L -35.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -47.765 -16.442 L -37.765 -16.442 L -37.765 -14.442 L -47.765 -14.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -16.442 L -29.765 -16.442 L -29.765 -6.442 L -31.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -31.765 -16.442 L -21.765 -16.442 L -21.765 -14.442 L -31.765 -14.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -19.765 -16.442 L -17.765 -16.442 L -17.765 -6.442 L -19.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -13.765 -16.442 L -11.765 -16.442 L -11.765 -6.442 L -13.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -7.765 -16.442 L -5.765 -16.442 L -5.765 -6.442 L -7.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -19.765 -8.442 L -5.765 -8.442 L -5.765 -6.442 L -19.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -47.765 -10.442 L -37.765 -10.442 L -37.765 -8.442 L -47.765 -8.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -3.765 -16.442 L -1.765 -16.442 L -1.765 -6.442 L -3.765 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 4.235 -16.442 L 6.235 -16.442 L 6.235 -6.442 L 4.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -3.765 -16.442 L 6.235 -16.442 L 6.235 -14.442 L -3.765 -14.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 8.235 -16.442 L 10.235 -16.442 L 10.235 -6.442 L 8.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 16.235 -16.442 L 18.235 -16.442 L 18.235 -6.442 L 16.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M 8.235 -8.442 L 18.235 -8.442 L 18.235 -6.442 L 8.235 -6.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
      <path
        d="M -3.765 -10.442 L 6.235 -10.442 L 6.235 -8.442 L -3.765 -8.442 Z"
        transform="matrix(1, 0, 0, 1, 49.308498, 34.424118)"
      />
    </svg>
  );
};
